const allAssessmentUploaded = async (url, abortController, token) => {
  abortController.current = new AbortController();
  const options = {
    signal: abortController.current.signal,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        `Failed for allAssessmentAudioUploaded api: ${JSON.stringify(errorResponse)} ${response.status}`
      );
    }
    return response.json();
  } catch (error) {
    throw new Error(`Error for allAssessmentAudioUploaded api`, {
      cause: error,
    });
  }
};

export default allAssessmentUploaded;
